import { useTranslation } from 'react-i18next'
import { assignmentIds, overdue } from '../lib/taskFilters'

const boardColors = ['#3443D4', '#D9730D', '#13795B', '#9B3C8C']
export function boardColor(id) {
  return boardColors[Array.from(id).reduce((value, char) => value + char.charCodeAt(0), 0) % boardColors.length]
}
export function BoardDot({ id }) { return <span className="board-dot" style={{ background: boardColor(id) }}/> }
export function TaskLabels({ task }) {
  return <span className="task-labels">{Object.entries(task.appliedCategories || {}).filter(([, on]) => on === true).map(([key]) => <span className="task-label" key={key}><i style={{background: boardColor(key)}}/>{task.board.labels[key] || key}</span>)}</span>
}
export function TaskAssignees({ task, people, user }) {
  const { t } = useTranslation()
  const ids = assignmentIds(task)
  if (!ids.length) return <span className="unassigned"><span className="empty-avatar"/>{t("Niet toegewezen")}</span>
  return <span className="task-avatars">{ids.map(id => {
    const name = id === user.microsoft_object_id ? user.name : people?.[id]
    return <span key={id} className="task-avatar" title={name || t("Naam niet beschikbaar · {{value0}}", { value0: id })} aria-label={name || t("Naam niet beschikbaar · {{value0}}", { value0: id })} style={{ background: boardColor(id) }}>{name ? name.trim().split(/\s+/).map(word => word[0]).slice(0, 2).join('').toUpperCase() : '?'}</span>
  })}</span>
}
export function TaskDeadline({ task }) {
  const { t, i18n } = useTranslation()
  return <span className={`task-deadline ${overdue(task) ? 'is-overdue' : ''}`}>{task.dueDateTime ? `${overdue(task) ? t("Te laat · ") : ''}${new Date(task.dueDateTime).toLocaleDateString(i18n.language, { day: 'numeric', month: 'short' })}` : t("Geen deadline")}</span>
}
